export default __webpack_public_path__ + "static/media/ja.fe958929.svg";